import UserData from "view3/UserData.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    categories: state.categories,
    alert: state.alert,
    // city: state.city,
    user: state.user
  };
}

const UserDataContainer = connectFunction(mapStateToProps)(UserData);
export default UserDataContainer;
